import { useEffect } from "react"

import {
  subscribeToAppEvent,
  unsubscribeFromAppEvent
} from "shared/lib/appEventEmitter"
import { AppEventType, EventHandlerByEventType } from "shared/types/AppEvent"

interface UseAppEventSubscriptionProps<T extends AppEventType> {
  eventType: T
  handler: EventHandlerByEventType<T>
}

export function useAppEventSubscription<T extends AppEventType>({
  eventType,
  handler
}: UseAppEventSubscriptionProps<T>) {
  useEffect(() => {
    subscribeToAppEvent(eventType, handler)
    return () => unsubscribeFromAppEvent(eventType, handler)
  }, [])
}
